module.exports = __webpack_public_path__ + "821b4198fe7570dbff26769e8c29219f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/hat-graduation.png
// module id = 2265
// module chunks = 0